import { Controller } from "@hotwired/stimulus"

// This controller helps keep the mobile keyboard open during form submission
// and element changes in Turbo Stream updates
export default class extends Controller {
  static targets = ["input"]

  connect() {
    // Store the active element position on form submission
    document.addEventListener("turbo:submit-start", this.storeActivePosition.bind(this))
    
    // Restore focus after Turbo Stream updates
    document.addEventListener("turbo:frame-render", this.restoreFocus.bind(this))
    
    // On mobile devices, make sure to scroll to the input field
    if (this.isMobileDevice()) {
      this.inputTarget.addEventListener("focus", this.scrollToInput.bind(this))
    }
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.storeActivePosition)
    document.removeEventListener("turbo:frame-render", this.restoreFocus)
    
    if (this.isMobileDevice()) {
      this.inputTarget.removeEventListener("focus", this.scrollToInput)
    }
  }

  storeActivePosition() {
    this.lastActiveElement = document.activeElement
    this.lastCursorPosition = this.getCursorPosition(this.lastActiveElement)
  }

  restoreFocus() {
    // Wait for DOM updates to complete
    setTimeout(() => {
      if (this.inputTarget) {
        this.inputTarget.focus()
        
        // If we stored a previous position, try to restore it
        if (this.lastCursorPosition) {
          this.setCursorPosition(this.inputTarget, this.lastCursorPosition)
        }
      }
    }, 50)
  }

  scrollToInput() {
    // Scroll the view to make sure the input is visible
    setTimeout(() => {
      this.inputTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 300)
  }

  getCursorPosition(element) {
    if (!element || !element.selectionStart) return null
    return element.selectionStart
  }

  setCursorPosition(element, position) {
    if (!element || !element.setSelectionRange) return
    element.setSelectionRange(position, position)
  }

  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }
}